interface IMemberPlan {//extends IPlan {
    ncpdp: string;
    memberId: number;
    planId: number;
    planName: string;
    label?: string;
}
export class MemberPlan implements IMemberPlan {
    public readonly ncpdp: string;
    public readonly memberId: number;
    public readonly planId: number;
    public readonly planName: string;
    public readonly label: string;
    // public readonly plan: Plan;

    constructor(memberPlan: IMemberPlan) {
        this.ncpdp = memberPlan.ncpdp;
        this.memberId = memberPlan.memberId;
        this.planId = memberPlan.planId;
        this.planName = memberPlan.planName;
        this.label = memberPlan.label ?? this.planName; 
        // this.plan = new Plan(memberPlan);
    }

    /*
    public get planId() { return this.plan.planId; }
    public get planName() { return this.plan.planName; }
    */

    public static sort(a: IMemberPlan, b: IMemberPlan) {
        return a.planName === b.planName ? a.planId - b.planId : a.planName.localeCompare(b.planName);
    }
}

/*
interface IPlan {
    planId: number;
    planName: string;
}
export class Plan implements IPlan {
    public readonly planId: number;
    public readonly planName: string;
    constructor(plan: IPlan) {
        this.planId = plan.planId;
        this.planName = plan.planName;
    }

    public static getDistinctPlans(plans: IPlan[]) : Plan[] {
        const planSet : Plan[] = [];
        plans.forEach(p => {
            if (!planSet.some(planSetItem => planSetItem.planId === p.planId)) {
                planSet.push(new Plan(p));
            }
        });
        return planSet.sort((a: Plan, b: Plan) => a.planName.localeCompare(b.planName));
    }
}
*/